import { render, staticRenderFns } from "./modal-task-link-column.vue?vue&type=template&id=1ec2d242&scoped=true&"
import script from "./modal-task-link-column.vue?vue&type=script&lang=ts&"
export * from "./modal-task-link-column.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec2d242",
  null
  
)

export default component.exports